import { render, staticRenderFns } from "./messageBoardAdd.vue?vue&type=template&id=1dcf3772&scoped=true"
import script from "./messageBoardAdd.vue?vue&type=script&lang=js"
export * from "./messageBoardAdd.vue?vue&type=script&lang=js"
import style0 from "./messageBoardAdd.vue?vue&type=style&index=0&id=1dcf3772&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dcf3772",
  null
  
)

export default component.exports